import React from 'react';
import {
  WarrantyOptionCard as StyledWarrantyOptionCard,
  WarrantyOptionHeader,
  WarrantyOptionTitle,
  WarrantyOptionRadio,
  WarrantyCoverageList,
  WarrantyCoverageItem,
  WarrantyCoverageItemMinor,
  WarrantyCoverageRow,
  WarrantyCoverageIcon,
  WarrantyCoverageText,
  WarrantyCoveragePeriod,
  WarrantyOptionPrice,
  WarrantyPlusIcon,
  PlusDivider,
} from '../styles/warrantyStyles';
import WarrantyCoverIcon from '../../../../../images/icons/warranty-cover.svg';
import WarrantyCalendarIcon from '../../../../../images/icons/warranty-calendar.svg';
import { formatPrice } from '../../../../../utils/formatPrice';

// Helper function to format coverage text with highlighted specific values
const formatCoverageText = (type, value) => {
  const formattedValue = formatPrice(value);
  // Only highlight values like R$10,000 (10000) and similar high values
  if (value === 10000) {
    return (
      <>
        Cobertura {type}: <span style={{ fontWeight: '500' }}>R${formattedValue}</span>
      </>
    );
  }
  return `Cobertura ${type}: R$${formattedValue}`;
};

// Helper function to format period text with highlighted specific periods
const formatPeriodText = period => {
  // Only highlight "30 dias" specifically
  if (period.includes('30 dias')) {
    return (
      <>
        <span style={{ fontWeight: '500' }}>30 dias</span>
        {period.replace('30 dias', '')}
      </>
    );
  }
  if (period.includes('120 dias')) {
    return (
      <>
        <span style={{ fontWeight: '500' }}>120 dias</span>
        {period.replace('120 dias', '')}
      </>
    );
  }
  return period;
};

export const WarrantyOptionCard = ({ option, isSelected, onClick, isMinor = false }) => {
  const CoverageItem = isMinor ? WarrantyCoverageItemMinor : WarrantyCoverageItem;

  return (
    <StyledWarrantyOptionCard selected={isSelected} onClick={onClick}>
      <WarrantyOptionHeader selected={isSelected}>
        <WarrantyOptionTitle color={isMinor ? '#00A81F' : '#000000'}>
          {option.title}
        </WarrantyOptionTitle>
        <WarrantyOptionRadio selected={isSelected} />
      </WarrantyOptionHeader>
      <WarrantyCoverageList>
        {option.coverages.map((coverage, index) => (
          <div key={index}>
            <CoverageItem>
              <WarrantyCoverageRow>
                <WarrantyCoverageIcon>
                  <img src={WarrantyCoverIcon} alt="Cobertura" />
                </WarrantyCoverageIcon>
                <WarrantyCoverageText>
                  {formatCoverageText(coverage.type, coverage.value)}
                </WarrantyCoverageText>
              </WarrantyCoverageRow>
              <WarrantyCoverageRow>
                <WarrantyCoverageIcon>
                  <img src={WarrantyCalendarIcon} alt="Período" />
                </WarrantyCoverageIcon>
                <WarrantyCoveragePeriod>{formatPeriodText(coverage.period)}</WarrantyCoveragePeriod>
              </WarrantyCoverageRow>
            </CoverageItem>
            {!isMinor && index === 0 && (
              <div
                style={{
                  margin: '0px 14px 10px 14px',
                  display: 'flex',
                  height: '37px',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <div style={{ borderTop: '1px solid #D2D4D7', flex: 1 }}></div>
                <PlusDivider>+</PlusDivider>
                <div style={{ borderTop: '1px solid #D2D4D7', flex: 1 }}></div>
              </div>
            )}
            {isMinor && index < option.coverages.length - 1 && <WarrantyPlusIcon />}
          </div>
        ))}
      </WarrantyCoverageList>
      <WarrantyOptionPrice>R${formatPrice(option.price)}</WarrantyOptionPrice>
    </StyledWarrantyOptionCard>
  );
};
